/** Format bytes to the same human-readable file size used across attachment surfaces. */
export function formatFileSize(bytes: number): string {
	if (bytes >= 1_000_000) {
		return `${(bytes / 1_000_000).toFixed(1)} MB`;
	}
	if (bytes >= 1_000) {
		return `${Math.round(bytes / 1_000)} KB`;
	}
	return `${bytes} B`;
}
